"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networks = void 0;
const metadata_1 = require("../metadata");
exports.networks = {
    ethereum: {
        name: metadata_1.chains.ethereum.name,
        image: metadata_1.chains.ethereum.image,
        networkId: 1,
        publicRpcUrl: 'https://mainnet.infura.io/v3/84842078b09946638c03157f83405213',
        fallbackPublicRpcUrls: [
            'https://rpc.ankr.com/eth'
        ],
        explorerUrls: ['https://etherscan.io'],
        waitConfirmations: 64,
        hasFinalizationBlockTag: true
    },
    arbitrum: {
        name: metadata_1.chains.arbitrum.name,
        image: metadata_1.chains.arbitrum.image,
        networkId: 42161,
        publicRpcUrl: 'https://arb1.arbitrum.io/rpc',
        fallbackPublicRpcUrls: [
            'https://arbitrum-mainnet.infura.io/v3/84842078b09946638c03157f83405213',
            'https://rpc.ankr.com/arbitrum'
        ],
        explorerUrls: ['https://arbiscan.io/'],
        nativeBridgeUrl: 'https://bridge.arbitrum.io/',
        waitConfirmations: 64,
        hasFinalizationBlockTag: true
    },
    optimism: {
        name: metadata_1.chains.optimism.name,
        image: metadata_1.chains.optimism.image,
        networkId: 10,
        publicRpcUrl: 'https://optimism-mainnet.infura.io/v3/84842078b09946638c03157f83405213',
        fallbackPublicRpcUrls: [
            'https://rpc.ankr.com/optimism',
            'https://mainnet.optimism.io'
        ],
        explorerUrls: ['https://optimistic.etherscan.io'],
        nativeBridgeUrl: 'https://gateway.optimism.io/welcome',
        waitConfirmations: 64,
        hasFinalizationBlockTag: true
    },
    gnosis: {
        name: metadata_1.chains.gnosis.name,
        image: metadata_1.chains.gnosis.image,
        networkId: 100,
        publicRpcUrl: 'https://rpc.gnosis.gateway.fm',
        fallbackPublicRpcUrls: [
            'https://rpc.ankr.com/gnosis',
            'https://rpc.gnosischain.com'
        ],
        explorerUrls: ['https://gnosisscan.io/'],
        nativeBridgeUrl: 'https://omni.xdaichain.com/',
        waitConfirmations: 20,
        hasFinalizationBlockTag: true
    },
    polygon: {
        name: metadata_1.chains.polygon.name,
        image: metadata_1.chains.polygon.image,
        networkId: 137,
        publicRpcUrl: 'https://polygon-rpc.com',
        fallbackPublicRpcUrls: [
            'https://rpc.ankr.com/polygon'
        ],
        explorerUrls: ['https://polygonscan.com'],
        nativeBridgeUrl: 'https://wallet.matic.network/bridge/',
        waitConfirmations: 1600,
        hasFinalizationBlockTag: false
    },
    nova: {
        name: metadata_1.chains.nova.name,
        image: metadata_1.chains.nova.image,
        networkId: 42170,
        publicRpcUrl: 'https://nova.arbitrum.io/rpc',
        fallbackPublicRpcUrls: [],
        explorerUrls: ['https://nova.arbiscan.io/'],
        nativeBridgeUrl: 'https://bridge.arbitrum.io/',
        waitConfirmations: 64,
        hasFinalizationBlockTag: true
    }
    /*
    zksync: {
      name: chains.zksync.name,
      image: chains.zksync.image,
      networkId: 324,
      publicRpcUrl: 'https://zksync2-mainnet.zksync.io',
      fallbackPublicRpcUrls: [],
      explorerUrls: ['https://explorer.zksync.io/'],
      nativeBridgeUrl: '',
      waitConfirmations: 1,
      hasFinalizationBlockTag: false
    }
    linea: {
      name: chains.linea.name,
      image: chains.linea.image,
      networkId: 0,
      publicRpcUrl: '',
      fallbackPublicRpcUrls: [],
      explorerUrls: [''],
      nativeBridgeUrl: '',
      waitConfirmations: 1,
      hasFinalizationBlockTag: false
    }
    */
};
